import { render, staticRenderFns } from "./RotaIcon.vue?vue&type=template&id=712fc92c&"
import script from "./RotaIcon.vue?vue&type=script&lang=js&"
export * from "./RotaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports